/**
 * Created by razial on 18.12.2023
 */

/* eslint-disable no-var,block-scoped-var */

if (typeof cc === "undefined") {
    GitManager = function () {};
}

GitManager.STATUS = "status";
GitManager.PUSH = "push";
GitManager.REVERT = "revert";

GitManager.STATE_READY = 0;
GitManager.STATE_BEHIND = 1;
GitManager.STATE_AHEAD = 2;
GitManager.STATE_DETACHED = 3;

GitManager.STATUS_EMPTY = "empty";
GitManager.STATUS_UNAVAILABLE = "unavailable";
GitManager.STATUS_PROCESSING = "processing";
GitManager.STATUS_ERROR = "error";
GitManager.STATUS_DETACHED = "detached";
GitManager.STATUS_REDY = "ready";

GitManager.FOLDERS = {};

if (cleverapps.config.type === "match3") {
    GitManager.FOLDERS.LEVELS = "match3/res/levels/";
}

if (cleverapps.config.type === "board") {
    GitManager.FOLDERS.LEVELS = "features/res/levels/*/";
}

if (cleverapps.config.type === "merge") {
    GitManager.FOLDERS.LEVELS = "merge3/res/*/locations/";
    GitManager.FOLDERS.EXPEDITION_LEVELS = "expedition/*/res/";
}

if (cleverapps.config.name === "wordsoup" || cleverapps.config.type === "farm") {
    GitManager.FOLDERS.LEVELS = "res/locations/";
}

if (cleverapps.config.name === "scramble") {
    GitManager.FOLDERS.LEVELS = "res/levels/";
}

if (cleverapps.config.type === "battlefield") {
    GitManager.FOLDERS.LEVELS = `res/${cleverapps.config.name}/levels/`;
}

if (cleverapps.config.type === "blocks") {
    GitManager.FOLDERS.LEVELS = "res/levels/";
}

if (cleverapps.config.type === "tile3") {
    GitManager.FOLDERS.LEVELS = "res/levels/";
}

if (cleverapps.config.type === "solitaire") {
    GitManager.FOLDERS.LEVELS = "features/res/levels/card/";
}

GitManager.FOLDERS.VILLAGES = "res/levels/villages.json";

GitManager.FOLDERS.UNIT_ANCHORS = "**/units/**/anchors.json";

GitManager.match = function (path, patterns) {
    path = path.split("/");

    return cleverapps.toArray(patterns).some((pattern) => {
        pattern = pattern.replace(/\/$/, "/**").split("/");

        const match = function (i, j) {
            for (; i < path.length || j < pattern.length;) {
                if (path[i] === "") {
                    i += 1;
                    continue;
                }

                if (pattern[j] === "") {
                    j += 1;
                    continue;
                }

                if (pattern[j] === "**") {
                    if (i >= path.length) {
                        j += 1;
                        continue;
                    }

                    if (match(i, j + 1)) {
                        return true;
                    }

                    i += 1;
                    continue;
                }

                if (pattern[j] === "*" || pattern[j] === path[i]) {
                    i += 1;
                    j += 1;
                    continue;
                }

                return false;
            }

            return true;
        };

        return match(0, 0);
    });
};

if (typeof cc === "undefined") {
    module.exports = GitManager;
}
